import { render, staticRenderFns } from "./AscDialogHeader.vue?vue&type=template&id=621a8aa0&scoped=true&"
import script from "./AscDialogHeader.vue?vue&type=script&lang=js&"
export * from "./AscDialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./AscDialogHeader.vue?vue&type=style&index=0&id=621a8aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a8aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
